import { Translate } from '@chipinside/translate'
import { Avatar, Box, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'

import CowmedChip from '#/components/Chip'
import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

const StyledReqCancellationBadge = styled(Avatar)({
  ...Colors.feedback.error,
  height: '24px',
  marginLeft: '6px',
  width: '24px',
})

const TypeContractStatus = ({ value }) => {
  if (!value) return <span>-</span>

  const { cancellation_requested: hasCancellationRequestBadge, status, text } = value

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row' }}>
      <CowmedChip style={Colors?.contract?.[status]} value={text} />
      {hasCancellationRequestBadge && (
        <Tooltip title={Translate({ messageKey: 'in_cancellation' })}>
          <StyledReqCancellationBadge>
            <Icon size="large" name="priority-high-rounded" sx={{ fontSize: 18 }} />
          </StyledReqCancellationBadge>
        </Tooltip>
      )}
    </Box>
  )
}
export { TypeContractStatus }
